/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakEscalationTier } from './StreakEscalationTier';
import {
    StreakEscalationTierFromJSON,
    StreakEscalationTierFromJSONTyped,
    StreakEscalationTierToJSON,
    StreakEscalationTierToJSONTyped,
} from './StreakEscalationTier';

/**
 * Escalating per-window outcomes that increase with streak length
 * @export
 * @interface StreakPerWindowEscalation
 */
export interface StreakPerWindowEscalation {
    /**
     * 
     * @type {Array<StreakEscalationTier>}
     * @memberof StreakPerWindowEscalation
     */
    tiers: Array<StreakEscalationTier>;
}

/**
 * Check if a given object implements the StreakPerWindowEscalation interface.
 */
export function instanceOfStreakPerWindowEscalation(value: object): value is StreakPerWindowEscalation {
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    return true;
}

export function StreakPerWindowEscalationFromJSON(json: any): StreakPerWindowEscalation {
    return StreakPerWindowEscalationFromJSONTyped(json, false);
}

export function StreakPerWindowEscalationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakPerWindowEscalation {
    if (json == null) {
        return json;
    }
    return {
        
        'tiers': ((json['tiers'] as Array<any>).map(StreakEscalationTierFromJSON)),
    };
}

export function StreakPerWindowEscalationToJSON(json: any): StreakPerWindowEscalation {
    return StreakPerWindowEscalationToJSONTyped(json, false);
}

export function StreakPerWindowEscalationToJSONTyped(value?: StreakPerWindowEscalation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tiers': ((value['tiers'] as Array<any>).map(StreakEscalationTierToJSON)),
    };
}

